import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { ICategories, ICategory } from '@interfaces/category';

export interface IGetCategoriesParams {
	search?: string;
	inactive?: boolean;
	isDefault?: boolean;
	menuDisplay?: boolean;
	tenantId?: number;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class CategoriesService {
	constructor(private readonly _http: HttpClient) {}

	getCategories(queryParams?: IGetCategoriesParams) {
		return this._http.get<ICategories>('categories', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	getCategory(id: ICategory['id']) {
		return this._http.get<ICategory>(`categories/${id}`);
	}

	newCategory(category: ICategory) {
		return this._http.post<ICategory>('categories', category);
	}

	editCategory(id: ICategory['id'], category: ICategory) {
		return this._http.put<ICategory>(`categories/${id}`, category);
	}

	deleteCategory(id: ICategory['id']) {
		return this._http.delete<ICategory>(`categories/${id}`);
	}

	activate(id: ICategory['id']) {
		return this._http.post<ICategory>(`categories/${id}/activate`, {});
	}
}
